module.exports = __webpack_public_path__ + "35093d58a0443b6bc5d8ea5a49de5632.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/herbs2peel logo.png
 ** module id = 458
 ** module chunks = 0
 **/